<template>
    <div class="form-field-filter-order" :ref="'filterOrderDialog-' + name">
        <label :id="'filterOrderDialog-' + name" class="sr-only">Order By</label>
        <div class="relative">
            <div class="inline-flex divide-x divide-sky-700 rounded-md shadow-sm">
                <div class="inline-flex items-center gap-x-1.5 rounded-l-md bg-sky-600 px-3 py-2 text-white shadow-sm">
                    <p class="text-sm font-semibold">{{currentItemText}}</p>
                </div>
                <button @click="toggleOpen" type="button" class="inline-flex items-center rounded-l-none rounded-r-md bg-sky-600 p-2 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-600 focus:ring-offset-2 focus:ring-offset-gray-50" :aria-expanded="isOpen" :aria-labelledby="'filterOrderDialog-' + name">
                    <span class="sr-only">Order By</span>
                    <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <ul :class="{'opacity-100': isOpen, 'opacity-0': !isOpen, 'hidden': !isOpen}" class="absolute right-0 z-10 mt-2 w-72 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition duration-100 ease-in focus:outline-none" tabindex="-1" role="listbox" :aria-labelledby="'filterOrderDialog-' + name">
                <!-- TODO - Improve accessibility and enable keyboard navigation switching highlighted option using mousemove events, aria active descendent etc -->
                <li v-for="item in items" :key="item[itemValue]" class="cursor-pointer select-none p-4 text-sm text-gray-900 hover:bg-sky-600 hover:text-white" role="option" @click="update(item)">
                    <div class="flex flex-col">
                        <div class="flex justify-between">
                            <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
                            <p :class="{
                                'font-semibold': item[itemValue] === value,
                                'font-normal': item[itemValue] !== value,
                            }">
                                {{item[itemText]}}
                            </p>
                            <span class="text-sky-600" :class="{'hidden': item[itemValue] !== value}">
                                <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                                </svg>
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormFieldFilterOrder',
    props: {
        name: {
            required: true,
            type: String,
        },
        items: {
            required: true,
            type: Array,
        },
        itemText: {
            required: true,
            type: String,
        },
        itemValue: {
            required: true,
            type: String,
        },
        field: {
            required: true,
            type: String,
        },
        value: {
            required: true,
        },
    },
    emits: ['update'],
    data () {
        return {
            isOpen: false,
        };
    },
    methods: {
        update (item) {
            this.$emit('update', item[this.itemValue]);
            this.isOpen = false;
        },
        toggleOpen () {
            this.isOpen = !this.isOpen;
        },
        handleClickOff (e) {
            const clickInThisItem = this.$refs['filterOrderDialog-' + this.name].contains(e.target);
            if (!clickInThisItem) this.isOpen = false;
        },
    },
    computed: {
        currentItemText () {
            if (!this.value) return null;
            const currentItem = this.items.find(item => item[this.itemValue] === this.value);
            return currentItem?.[this.itemText];
        }
    },
    mounted () {
        window.addEventListener('click', this.handleClickOff);
    },
    beforeUnmount () {
        window.removeEventListener('click', this.handleClickOff);
    }
};
</script>
